// Types
import { StopInterface } from 'store/ducks/stops/types';
import { PointInterface } from 'components/LeafletMapComponent';

/**
 * Factory the data used by the map.
 */
function factoryDataMap(
  point: StopInterface,
  markerUrl: string,
): PointInterface {
  return {
    location: {
      lat: (point.startLat + point.endLat) / 2,
      lng: (point.startLong + point.endLong) / 2,
    },
    marker: {
      url: markerUrl,
      info: {
        primary: point.name,
        secondary: ``,
      },
    },
  };
}

/**
 * Converts Degrees and Decimal Minutes (DMM) coordinates to Decimal Degrees (DD).
 */
function parseDMMToDD(lat: string, lng: string): { lat: number; lng: number } {
  try {
    const latDeg = parseFloat(lat.slice(0, 2));
    const latMin = parseFloat(lat.slice(2, 11));
    const latHemisphere = lat.slice(12, 13);
    const lngDeg = parseFloat(lng.slice(0, 3));
    const lngMin = parseFloat(lng.slice(3, 12));
    const lngHemisphere = lng.slice(13, 14);
    const ddLat = parseFloat((latDeg + latMin / 60).toFixed(8));
    const ddLng = parseFloat((lngDeg + lngMin / 60).toFixed(8));
    return {
      lat: latHemisphere === 'S' ? ddLat * -1 : ddLat,
      lng: lngHemisphere === 'W' ? ddLng * -1 : ddLng,
    };
  } catch (e) {
    return { lat: -1, lng: -1 };
  }
}

export { factoryDataMap, parseDMMToDD };
